import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import emojiFlags from 'emoji-flags';
import { Link } from 'react-router-dom';
import { KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers';
import { CustomerDrop } from '../Customer/CustomerDrop';
import Add from '../../../../public/media/icons/duotune/arrows/+icon.svg'
import Select from 'react-select';
import { Country, State, City } from 'country-state-city';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { ToastContainer, toast } from 'react-toastify';
import loadingimage from "../../../Assets/loading-buffering1.gif"
import moment from 'moment';



type Customer = {
    id: number;
    image?: string;
    name: string;
    email: string;
    mobile: string;
    country: string;
    city: string;
    state: string;
    pincode: string;
    user_id: string;
    created_at: string;
    active_status: string;
    customers_id: string;
    landmark: string;
    address: string;
    stateid: string;
};

interface CreditDetail {
    type: string;
    id: number;
    customers_id: string;
    customer: string;
    booking_id: string;
    credit_value: string;
    outstanding_value?: string;
    credit_status?: string;
    outstanding_status?: string;
    credit_created_at?: string;
    outstanding_created_at?: string;
    created_at: string;
    active_status: string;
    paided_amount: string;
    amount_received_date: string;
    total_discount_given: string;
    shipment_id?: string;
    shipment_status?: string;
    booking_value?: string;
    total_quantity?: string;
    split_id?: string;
    paidamount?: string;
    who_paid?: string;
    discount?: string;
}


interface CreditData {
    consignor: CreditDetail[];
    consignee: CreditDetail[];
    totals?: {
        total_received_amount: string;
        total_booking_value: string;
        total_discount_given: string;
        total_credit_value: string;
    };
}

type Props = {
    className: string;

};


const CustomerTable: React.FC<Props> = ({ className }) => {
    const [customers, setCustomers] = useState<Customer[]>([]);

    const [selectedCustomers, setSelectedCustomers] = useState<Customer[]>([]);
    const [error, setError] = useState<string | null>(null);
    const [searchValue, setSearchValue] = useState<string | null>('');
    const [loading, setLoading] = useState<boolean>(true);
    const [isMasterChecked, setIsMasterChecked] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [editingCustomer, setEditingCustomer] = useState<Customer | null>(null);
    const [showSuccessMessage, setShowSuccessMessage] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [filteredCustomerList, setFilteredCustomerList] = useState<Customer[]>([]);
    const [createdDateFrom, setCreatedDateFrom] = useState<Date | undefined>(undefined);
    const [createdDateTo, setCreatedDateTo] = useState<Date | undefined>(undefined);

    const [country, setCountry] = useState({ value: '', label: '' });
    const [state, setState] = useState({ value: '', label: '' });
    const [city, setCity] = useState({ value: '', label: '' });
    const [states, setStates] = useState<{ value: string; label: string }[]>([]);
    const [cities, setCities] = useState<{ value: string; label: string }[]>([]);
    const [consigneeHistory, setConsigneeHistory] = useState<CreditDetail[]>([]);
    const [consignorHistory, setConsignorHistory] = useState<CreditDetail[]>([]);
    const [showHistoryModal, setShowHistoryModal] = useState<boolean>(false);
    const [whoPaid, setWhoPaid] = useState<string | null>(null);
    const [showDeleteConfirmationMessage, setShowDeleteConfirmationMessage] = useState(false);
    const [customerToDeleteId, setCustomerToDeleteId] = useState<string | null>(null);

    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [customerData, setCustomerData] = useState<Customer | null>(null);
    const [showCreditModal, setShowCreditModal] = useState(false);
    const [consigneeCredit, setConsigneeCredit] = useState<number[]>([]);
    const [consignorCredit, setConsignorCredit] = useState<number[]>([]);
    const [creditData, setCreditData] = useState<CreditData | null>(null);
    const [creditLoadingId, setCreditLoadingId] = useState<string | null>(null);
    const [progress, setProgress] = React.useState<number>(0);
    const [showProgressBar, setShowProgressBar] = React.useState<boolean>(false);

    const getBadgeClass = (status: string) => {

        switch (status?.trim().toLowerCase()) {
            case "shipment started":
                return "badge badge-light-info";
            case "collected for shipment":
            case "collected to shipment":
                return "badge badge-light-success";
            case "delivered to hub":
                return "badge badge-light-warning";
            case "shipment progress":
                return "badge badge-light-warning";
            case "shipment ended":
            case "pending":
                return "badge badge-light-danger";
            case "delivered":
            case "delivered shipment":
                return "badge badge-light-success";
            case "main booking":
                return "badge badge-light-primary";
            default:
                return "badge badge-light-secondary";
        }
    };

    const [errorss, setErrorss] = useState<{
        mobile?: string;
    }>({});
    const itemsPerPage = 10;
    const [includeOutstanding, setIncludeOutstanding] = useState<boolean>(false);

    const fetchCustomers = async ({ statuses }: { statuses?: string[] } = { statuses: [] }) => {
        setLoading(true);

        try {
            const response = await fetch(
                "https://backendcway.causewaycargo.com/superadmin/getallcustomersdetails",
                {
                    method: 'GET',
                    headers: {
                        'auth': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do',
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();

            if (result.status === "success") {
                let filteredData = result.data as Customer[];

                console.log("Fetched Customers:", filteredData);

                if (statuses && statuses.length > 0) {
                    filteredData = filteredData.filter(customer =>
                        statuses.includes(customer.user_id)
                    );
                }


                setCustomers(filteredData);
                setFilteredCustomerList(filteredData);
                setError(null);
            } else {
                throw new Error("Failed to fetch data");
            }
        } catch (err) {
            setError(err instanceof Error ? `Error: ${err.message}` : "An unknown error occurred");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCustomers({ statuses: [] });
    }, []);


    const handleAddCustomerRedirect = () => {
        window.location.href = '/metronic8/react/demo1/customer';
    };

    const handleEditCustomer = (customer: Customer) => {
        setEditingCustomer(customer);
        setShowModal(true);
        console.log("particular customer", customer)
    };

    //-------------edit Customer---------------


    const handleEditFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!editingCustomer) return;

        if (editingCustomer.mobile.length === 0) {
            toast.error('Please enter a valid number.');
            return;
        }
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!editingCustomer.email || !emailRegex.test(editingCustomer.email)) {
            toast.error('Invalid email address. Please enter a valid email.');
            return;
        }

        // if (!isValidPhoneNumber(editingCustomer.mobile)) {
        //     toast.error('Invalid phone number. Please enter a valid number.');
        //     return;
        // }      


        console.log('Country:', country);
        console.log('State:', state);
        console.log('City:', city);

        try {
            const response = await fetch('https://backendcway.causewaycargo.com/superadmin/editcustomerdetail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do',
                },
                body: JSON.stringify({
                    id: editingCustomer.id,
                    name: editingCustomer.name,
                    email: editingCustomer.email,
                    mobile: editingCustomer.mobile,
                    country: country.label,
                    state: state.label,
                    city: city.label,
                    address: editingCustomer.address,
                    landmark: editingCustomer.landmark,
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                if (errorData.length > 0) {
                    const firstErrorMessage = errorData.errors.length > 0 ? errorData.errors[0].msg : errorData.message;
                    throw new Error(firstErrorMessage)
                } else {
                    const firstErrorMessage = errorData.message;
                    throw new Error(firstErrorMessage)
                }
            }

            const result = await response.json();

            if (result.status === 'success') {
                const updatedCustomers = customers.map(cust =>
                    cust.id === editingCustomer.id ? { ...cust, ...editingCustomer } : cust
                );
                setCustomers(updatedCustomers);
                setShowModal(false);
                setShowSuccessMessage(true);
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 2000);
                setSearchValue("");
                fetchCustomers();
            } else {
                toast.error(result.message || 'Failed to edit customer details');
            }
        } catch (err) {
            console.error('Fetch error:', err);
            toast.error(err instanceof Error ? err.message : 'An unknown error occurred');
        } finally {
            setLoading(false);
        }
    };


    //-----------------------------------------------------------------------

    const handleAlterPhoneChange = (value?: string) => {
        if (editingCustomer) {
            editingCustomer.mobile = value || '';

            if (value && !isValidPhoneNumber(value)) {
                setErrorss((prevErrors) => ({
                    ...prevErrors,
                    mobile: 'Invalid phone number',
                }));
            } else {
                setErrorss((prevErrors) => ({
                    ...prevErrors,
                    mobile: '',
                }));
            }
        }
    };



    const countries = Country.getAllCountries().map((c) => ({
        value: c.isoCode,
        label: c.name,
    }));

    useEffect(() => {
        if (editingCustomer) {
            const countryData =
                countries.find((c) => c.label === editingCustomer?.country) || {
                    value: "",
                    label: "",
                };
            setCountry(countryData);

            if (countryData.value) {
                const updatedStates = State.getStatesOfCountry(countryData.value).map((s) => ({
                    value: s.isoCode,
                    label: s.name,
                }));
                setStates(updatedStates);

                const stateData =
                    updatedStates.find((s) => s.label === editingCustomer?.state) || {
                        value: "",
                        label: "",
                    };
                setState(stateData);

                if (stateData.value) {
                    const updatedCities = City.getCitiesOfState(countryData.value, stateData.value).map((c) => ({
                        value: c.name,
                        label: c.name,
                    }));
                    setCities(updatedCities);

                    const cityData =
                        updatedCities.find((c) => c.label === editingCustomer?.city) || {
                            value: "",
                            label: "",
                        };
                    setCity(cityData);
                }
            }
        }
    }, [editingCustomer]);

    const handleCountryChange = (selectedOption: any) => {
        console.log("Country changed to:", selectedOption);
        setCountry(selectedOption || { value: "", label: "" });
        setState({ value: "", label: "" });
        setCity({ value: "", label: "" });

        if (selectedOption?.value) {
            const updatedStates = State.getStatesOfCountry(selectedOption.value).map((s) => ({
                value: s.isoCode,
                label: s.name,
            }));
            setStates(updatedStates);
        } else {
            setStates([]);
        }
    };

    const handleStateChange = (selectedOption: any) => {
        console.log("Selected State:", selectedOption);
        setState(selectedOption || { value: "", label: "" });
        setCity({ value: "", label: "" });

        if (selectedOption?.value) {
            const updatedCities = City.getCitiesOfState(country.value, selectedOption.value).map((c) => ({
                value: c.name,
                label: c.name,
            }));
            setCities(updatedCities);
        } else {
            setCities([]);
        }
    };

    const handleCityChange = (selectedOption: any) => {
        console.log("Selected City:", selectedOption);
        setCity(selectedOption || { value: "", label: "" });
    };


    //----editing over--------------------------
    const handleExportToExcel = () => {
        const dataToExport = selectedCustomers.length > 0 ? selectedCustomers : [];

        if (dataToExport.length === 0) {
            alert("No data selected to export!");
            return;
        }

        setShowProgressBar(true); // Show the progress bar
        setProgress(0); // Start progress from 0%

        const startTime = Date.now();
        const estimatedTime = 5000; // assume export takes around 5 seconds (adjust if needed)

        const intervalId = setInterval(() => {
            const elapsedTime = Date.now() - startTime;
            const progressPercentage = Math.min((elapsedTime / estimatedTime) * 100, 100);
            setProgress(progressPercentage);

            if (progressPercentage >= 100) {
                clearInterval(intervalId);
            }
        }, 100); // update every 100ms

        // Proceed to format data and export
        setTimeout(() => {
            const filteredData = dataToExport.map(({ user_id, name, email, mobile, address, country, state, city, landmark, created_at }) => ({
                user_id,
                name,
                email: email || "N/A",
                mobile: mobile || "N/A",
                address: address || "N/A",
                country: country || "N/A",
                state: state || "N/A",
                city: city || "N/A",
                landmark: landmark || "N/A",
                created_at: created_at ? new Date(created_at).toLocaleString("en-GB") : "N/A"
            }));

            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(filteredData);

            // Set column widths
            ws['!cols'] = [
                { wch: 25 },
                { wch: 30 },
                { wch: 35 },
                { wch: 20 },
                { wch: 40 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 30 },
                { wch: 25 }
            ];

            XLSX.utils.book_append_sheet(wb, ws, "Selected_Customers");
            XLSX.writeFile(wb, "Selected_Customers.xlsx");

            setProgress(100); // Ensure it finishes at 100%
            setShowProgressBar(false); // Hide progress bar after export
        }, estimatedTime); // Delay export to simulate progress
    };




    const isCustomerSelected = (customer: Customer) => {
        return selectedCustomers.some(c => c.id === customer.id);
    };

    const handleCheckboxChange = (customer: Customer, isChecked: boolean) => {
        if (isChecked) {
            setSelectedCustomers(prev => [...prev, customer]);
        } else {
            setSelectedCustomers(prev => prev.filter(c => c.id !== customer.id));
        }
    };

    const handleMasterCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = e.target.checked;
        setIsMasterChecked(isChecked);

        if (isChecked) {
            setSelectedCustomers(dataToPaginate);
        } else {
            setSelectedCustomers([]);
        }
    };

    const countryNameToCodeMap: { [key: string]: string } = emojiFlags.data.reduce((map, country) => {
        map[country.name] = country.code;
        return map;
    }, {} as { [key: string]: string });


    const getCountryFlagFromName = (countryName: string) => {
        const countryCode = countryNameToCodeMap[countryName];

        if (!countryCode) {
            console.error(`Country code not found for country name: ${countryName}`);
            return '🏳';
        }

        return getCountryFlag(countryCode);
    };

    const getCountryNameFromName = (countryName: string) => {
        const countryCode = countryNameToCodeMap[countryName];

        if (!countryCode) {
            console.error(`Country code not found for country name: ${countryName}`);
            return 'Unknown Country';
        }

        return getCountryName(countryCode);
    };

    const getCountryFlag = (countryCode: string) => {
        const flag = emojiFlags.countryCode(countryCode);
        return flag ? flag.emoji : '🏳';
    };

    const getCountryName = (countryCode: string) => {
        const country = emojiFlags.countryCode(countryCode);
        return country ? country.name : 'Unknown Country';
    };

    const countryName = 'India';

    //--------------pagination---------------

    const dataToPaginate = filteredCustomerList
        ? filteredCustomerList
        : customers.length > 0
            ? filteredCustomerList
            : customers;

    const totalPages = Math.ceil(dataToPaginate.length / itemsPerPage);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentCustomers = dataToPaginate.slice(
        startIndex,
        startIndex + itemsPerPage
    );

    const handlePageChange = (page: number) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };
    useEffect(() => {
        setCurrentPage(1);
    }, [filteredCustomerList]);

    //----------------------------Customer Delete------------------------


    const handleDeleteCustomer = (customerId: string) => {
        setCustomerToDeleteId(customerId);
        setShowDeleteConfirmationMessage(true);
    };

    const confirmDeleteCustomer = async () => {
        if (customerToDeleteId !== null) {
            try {
                const response = await fetch('https://backendcway.causewaycargo.com/superadmin/deletecustomer', {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'auth': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do'
                    },
                    body: JSON.stringify({ user_id: customerToDeleteId }),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                console.log('Delete Customer API Response:', result);

                if (result.status === 'success') {
                    setCustomers(prevCustomers => prevCustomers.filter(customer => customer.user_id !== customerToDeleteId));
                    setFilteredCustomerList(prevCustomers => prevCustomers.filter(customer => customer.user_id !== customerToDeleteId));
                    console.log('Customer deleted successfully');

                    fetchCustomers({
                        statuses: [],
                    });
                } else {
                    console.error('Failed to delete customer:', result.message);
                }
            } catch (error) {
                console.error('Error deleting customer:', error);
                alert('An error occurred while deleting the customer. Please try again.');
            } finally {
                setShowDeleteConfirmationMessage(false);
                setCustomerToDeleteId(null);
            }
        }
    };

    //--------------------------CustomerView---------------------------------



    const handleCustomerView = async (userId: any) => {
        try {
            const response = await fetch('https://backendcway.causewaycargo.com/superadmin/viewparticularcustomer', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do'
                },
                body: JSON.stringify({ customers_id: userId }),
            });

            if (response.ok) {
                const data = await response.json();
                console.log("particular customer", data)
                setCustomerData(data.data);
                setShowCustomerModal(true);
            } else {
                console.error('Failed to fetch customer data');
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    //-------------------------Creadit view------------------------------


    const exportCreditData = (data: CreditData) => {
        // Prepare data for export
        const exportData: (any)[][] = [];

        // Add headers - updated to match all columns in the table
        const headers = [
            'Type', 'Customer', 'Booking ID', 'Shipment ID',
            'Credit Value', 'Total Received Amount', 'Booking created',
            'Total Discount', 'Amount Received Date', 'Shipment Status'
        ];
        exportData.push(headers);

        // Helper function to format date
        const formatDate = (dateStr: string | null) => {
            if (!dateStr) return 'N/A';
            const date = new Date(dateStr);
            date.setMinutes(date.getMinutes() + 330);
            return new Intl.DateTimeFormat('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            }).format(date);
        };

        // Add consignor data
        if (data.consignor?.length) {
            data.consignor.forEach((item: any) => {
                exportData.push([
                    'Consignor',
                    item.customer || 'N/A',
                    item.booking_id || 'N/A',
                    item.shipment_id || 'N/A',
                    item.credit_value || 'N/A',
                    item.paided_amount || 'N/A',
                    formatDate(item.created_at),
                    item.total_discount_given || 'N/A',
                    formatDate(item.amount_received_date),
                    item.shipment_status === "Shipment Started" ? "In Transit" : item.shipment_status || "N/A"
                ]);
            });
        }

        // Add consignee data
        if (data.consignee?.length) {
            data.consignee.forEach((item: any) => {
                exportData.push([
                    'Consignee',
                    item.customer || 'N/A',
                    item.booking_id || 'N/A',
                    item.shipment_id || 'Shipment Not Yet Started',
                    item.credit_value || 'N/A',
                    item.paided_amount || 'N/A',
                    formatDate(item.created_at),
                    item.total_discount_given || 'N/A',
                    formatDate(item.amount_received_date),
                    item.shipment_status === "Shipment Started" ? "In Transit" : item.shipment_status || "N/A"
                ]);
            });
        }

        // Add an empty row for spacing
        exportData.push([]);

        // Add totals at the bottom
        exportData.push(['', '', '', '', 'Total Booking Value:', data.totals?.total_booking_value || 0]);
        exportData.push(['', '', '', '', 'Total Received Amount:', data.totals?.total_received_amount || 0]);
        exportData.push(['', '', '', '', 'Total Credit Amount:', data.totals?.total_credit_value || 0]);

        // Convert array to worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(exportData);

        // Auto-size columns
        worksheet['!cols'] = headers.map(header => ({
            wch: Math.max(
                header.length,
                ...exportData.slice(1).map(row => String(row[headers.indexOf(header)] || '').length)
            )
        }));

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Credit Data');

        // Create an XLSX file and trigger download
        XLSX.writeFile(workbook, `credit_data_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    const handleCreditView = async (userId: string) => {
        try {
            setCreditLoadingId(userId);


            const response = await fetch('https://backendcway.causewaycargo.com/superadmin/customercredits', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do'
                },
                body: JSON.stringify({ customers_id: userId }),
            });

            if (response.ok) {
                const data = await response.json();
                console.log("customer credits", data);

                const consigneeCredits = data.data.consignee.map((item: CreditDetail) => item.credit_value);
                const consignorCredits = data.data.consignor.map((item: CreditDetail) => item.credit_value);

                setConsigneeCredit(consigneeCredits);
                setConsignorCredit(consignorCredits);
                setCreditData(data.data);
                setShowCreditModal(true);
            } else {
                console.error('Failed to fetch credit data');
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setCreditLoadingId(null);

        }
    };


    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        // Store the original input value
        setSearchValue(e.target.value);

        // Process for filtering only
        const query = e.target.value.trim().toLowerCase().replace(/\s+/g, "");

        const filteredData = customers.filter((customer) => {
            return (
                customer.name?.toLowerCase().replace(/\s+/g, "").includes(query) ||
                customer.email?.toLowerCase().includes(query) ||
                customer.user_id?.toString().toLowerCase().includes(query)
            );
        });

        setFilteredCustomerList(filteredData);
    };


    // close button inside of customer edit popup...........

    const closeTab = () => {
        fetchCustomers()
        setSearchValue("")
        setShowModal(false)
    }

    // close icon right corner inside of customer edit popup...........

    const closeIcon = () => {
        fetchCustomers()
        setSearchValue("")
        setShowModal(false)
    }

    console.log("searchvalue", searchValue)
    console.log("isMasterChecked", isMasterChecked)
    console.log("filteredCustomerList", filteredCustomerList)

    //-----------------------payment History-----------------------
    const fetchPaymentHistory = async (BookingID: string, type: string) => {
        setWhoPaid(type.toLowerCase());
        console.log("whopaid", type)
        try {
            const response = await fetch(
                "https://backendcway.causewaycargo.com/superadmin/customerpaymenthistory",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        auth: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do",
                    },
                    body: JSON.stringify({ booking_id: BookingID }),
                }
            );

            if (response.ok) {
                const result = await response.json();
                console.log("Payment History Data:", result);

                if (result.status === "success") {
                    setConsigneeHistory(Array.isArray(result.consignee) ? result.consignee : []);
                    setConsignorHistory(Array.isArray(result.consignor) ? result.consignor : []);
                    console.log("payment History", result.data);
                    setShowHistoryModal(true);
                } else {
                    console.error("Failed to fetch payment history");
                }
            } else {
                console.error("API Request Failed:", response.status);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };



    return (
        <div className={`card px-lg-3 ${className} border-dark flex`}>
            {showProgressBar && (
                <>
                    <div className="modal-backdrop shadow-lg rounded-5">
                        <div className="modal d-block" tabIndex={-1} role="dialog">
                            <div
                                className="modal-dialog modal-dialog-centered"
                                role="document"
                            >
                                <div className="modal-content pb-10 pt-4">
                                    <div className="modal-header py-2 d-flex justify-content-end">
                                        <div className="modal-body">
                                            <h5 className="mb-4">Exporting Data...</h5>
                                            <div className="progress" style={{ height: "20px" }}>
                                                <div
                                                    className="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                                                    role="progressbar"
                                                    style={{ width: `${progress}%` }}
                                                    aria-valuenow={progress}
                                                    aria-valuemin={0}
                                                    aria-valuemax={100}
                                                >
                                                    {Math.round(progress)}%
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            <div className='card-header border-0 px-4 pt-5'>
                <div className="d-flex align-items-center">
                    <h3 className='card-title align-items-start flex-column me-6'>
                        <span className='card-label fw-bolder fs-3 mb-1'>Customers</span>
                        <span className='text-muted mt-1 fw-bold fs-7'>Total {customers.length?.toLocaleString()} Customers</span>
                    </h3>

                    <div className="input-group d-flex align-items-center border-dark border py-2 rounded-3 w-xl-200px w-md-150px">
                        <span
                            className=" bg-white px-2 border-0 h-25"

                            id="search-icon"
                        >
                            <i className="bi bi-search"></i>
                        </span>
                        <input
                            type="search"
                            className="form-control py-0 border-0 shadow-none"
                            placeholder="Search..."
                            aria-label="Search"
                            aria-describedby="search-icon"
                            value={searchValue ?? ""}
                            onChange={(e) => handleSearch(e)}
                        />
                    </div>
                </div>

                <div className='menu-item mt-2'>
                    <div className='d-flex justify-content-end'>

                        <span className='btn btn-primarys btn-sm px-4 me-2 text-white'>
                            <Link to='/customerTable/customerform' className='text-white d-flex align-items-center'>
                                {/* <KTSVG path='/media/icons/duotune/arrows/+icon.svg' className='svg-icon-3 me-2' /> */}
                                <img src={toAbsoluteUrl('/media/icons/duotune/arrows/+icon.svg')} alt="" width={10} className='svg-icon-3 me-2' />
                                Add Customer
                            </Link>
                        </span>

                        <button
                            className='btn btn-danger btn-sm px-4'
                            onClick={handleExportToExcel}
                            disabled={selectedCustomers.length === 0}
                        >
                            Export to Excel
                        </button>

                    </div>
                </div>

            </div>

            <div className='card-body py-3 '>
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                        <img src={loadingimage} alt="Loading..." className="w-20" />
                    </div>

                ) : (
                    <div className='table-responsive'>
                        <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
                            <thead>
                                <tr className='fw-bolder text-muted'>
                                    <th className='w-25px'>
                                        <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                            <input
                                                className='form-check-input'
                                                type='checkbox'
                                                checked={isMasterChecked}
                                                onChange={handleMasterCheckboxChange}
                                            />
                                        </div>
                                    </th>
                                    <th className='min-w-120px'>Customer ID</th>
                                    <th className='min-w-120px'>Name</th>
                                    <th className='min-w-140px'>Email ID</th>
                                    <th className='min-w-120px'>Phone</th>
                                    <th className='min-w-120px'>Country</th>
                                    {/* <th className='min-w-120px'>City</th> */}
                                    <th className='min-w-120px'>Credit</th>
                                    <th className='min-w-100px text-end'>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentCustomers.map((customer, index) => (
                                    <tr key={index}>
                                        <td>
                                            <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                                <input
                                                    className='form-check-input widget-13-check'
                                                    type='checkbox'
                                                    checked={isCustomerSelected(customer)}
                                                    onChange={(e) => handleCheckboxChange(customer, e.target.checked)}
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <a href='#' className='text-dark fw-bolder text-hover-primary' onClick={() => handleCustomerView(customer.user_id)}>
                                                {customer.user_id || 'N/A'}
                                            </a>
                                        </td>
                                        <td>{customer.name}</td>
                                        <td>{!customer.email || customer.email === "NULL" ? 'N/A' : customer.email}</td>
                                        <td>{customer.mobile}</td>
                                        <td>
                                            <div className="country-flag-container" style={{ cursor: 'pointer' }}>
                                                {!customer.country || customer.country === "NULL"
                                                    ? 'N/A'
                                                    : customer.country}
                                            </div>
                                        </td>



                                        <td>
                                            <div onClick={() => handleCreditView(customer.user_id)} style={{ cursor: 'pointer' }}>
                                                {creditLoadingId === customer.user_id ? (
                                                    <span className="spinner-border spinner-border-sm text-success" role="status" />
                                                ) : (
                                                    <KTSVG path='/media/icons/duotune/finance/fin008.svg' className='svg-icon-3' />
                                                )}
                                            </div>
                                        </td>

                                        <td className='text-end'>
                                            <button
                                                className='btn btn-icon btn-light btn-hover-primary btn-sm me-1'
                                                onClick={() => handleEditCustomer(customer)}
                                            >
                                                <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                                            </button>
                                            <button
                                                className='btn btn-icon btn-light btn-hover-danger btn-sm'
                                                onClick={() => handleDeleteCustomer(customer?.user_id)}
                                            >
                                                <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {currentCustomers.length > 0 ? (
                            <div className='d-flex justify-content-center mt-3 mb-3'>
                                <button
                                    className='btn btn-light-primary me-1 px-4 py-2'
                                    disabled={currentPage === 1}
                                    onClick={() => handlePageChange(currentPage - 1)}
                                >
                                    <KTSVG path='/media/icons/duotune/arrows/arr079.svg' className='svg-icon-3' />
                                </button>
                                <div>
                                    {Array.from({ length: totalPages }, (_, i) => {
                                        const pageNumber = i + 1;

                                        if (
                                            pageNumber === 1 ||
                                            pageNumber === totalPages ||
                                            (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
                                        ) {
                                            return (
                                                <button
                                                    key={pageNumber}
                                                    className={`btn btn-light-primary mx-1 px-4 py-2 ${currentPage === pageNumber ? 'active' : ''
                                                        }`}
                                                    onClick={() => handlePageChange(pageNumber)}
                                                >
                                                    {pageNumber}
                                                </button>
                                            );
                                        }

                                        if (
                                            pageNumber === currentPage - 2 ||
                                            pageNumber === currentPage + 2
                                        ) {
                                            return (
                                                <span key={pageNumber} className="mx-2 text-muted">
                                                    ...
                                                </span>
                                            );
                                        }

                                        return null;
                                    })}
                                </div>
                                <button
                                    className='btn btn-light-primary px-4 py-2 ms-1'
                                    disabled={currentPage === totalPages}
                                    onClick={() => handlePageChange(currentPage + 1)}
                                >
                                    <KTSVG path='/media/icons/duotune/arrows/arr080.svg' className='svg-icon-3' />
                                </button>
                            </div>
                        ) : (
                            <div className="text-center py-4 text-gray-500"> 🚫 No Customers Available</div>
                        )}

                    </div>
                )}
            </div>

            {showCreditModal && creditData !== null && (
                <div className="modal-backdrop rounded-5 d-flex align-items-center justify-content-center">
                    <div className="modal d-block" tabIndex={-1} role="dialog">
                        <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: '88vw' }}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Customer Credits</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowCreditModal(false)}></button>
                                </div>
                                <div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                                    <div className="table-responsive">
                                        <table className="table table-striped table-hover align-middle border rounded shadow-sm">
                                            <thead className="bg-dark text-white">
                                                <tr>
                                                    <th className="px-3">Type</th>
                                                    <th className="px-3">Customer</th>
                                                    <th className="px-3">Booking Created</th>
                                                    <th className="px-3">Booking ID</th>
                                                    <th className="px-3">Total Quantity</th>
                                                    <th className="px-3">Total Price</th>
                                                    <th className="px-3">Shipment ID</th>
                                                    <th className="px-3">Shipment Status</th>
                                                    <th className="px-3">Credit Value</th>
                                                    <th className="px-3">Total Received Amount</th>
                                                    <th className="px-3">Total Discount</th>
                                                    <th className="px-3">Payment History</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(!creditData.consignor?.length && !creditData.consignee?.length) ? (
                                                    <tr>
                                                        <td colSpan={12} className="text-center py-4 text-gray-500">🚫 No Credit Available
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <>
                                                        {creditData.consignor?.map((consignor, index) => (
                                                            <tr key={`consignor-${index}`} className="border-bottom">
                                                                <td className="px-3 fw-bold text-capitalize">{consignor.type}</td>
                                                                <td className="px-3 fw-bold">{consignor.customer || "N/A"}</td>
                                                                <td className="px-3">{moment(consignor?.created_at).format('DD-MM-YYYY')}</td>
                                                                <td className="px-3">{consignor.booking_id || "N/A"}</td>
                                                                <td className="px-3">{consignor.total_quantity}</td>
                                                                <td className="px-3">{consignor.booking_value} QAR</td>
                                                                <td className="px-3">{consignor.shipment_id || "N/A"}</td>
                                                                <td>
                                                                    <span className={`badge ${getBadgeClass(consignor?.shipment_status || "N/A")}`}>
                                                                        {consignor?.shipment_status === "Shipment Started" ? "In Transit" : consignor?.shipment_status}
                                                                    </span>
                                                                </td>
                                                                <td className="px-3 text-danger fw-bold">
                                                                    {consignor.credit_value === 'NaN' || Number(consignor.credit_value) === 0
                                                                        ? 0
                                                                        : `${consignor.credit_value} QAR`}
                                                                </td>

                                                                <td className="px-3 text-success fw-bold">{consignor.paided_amount || "N/A"} QAR</td>
                                                                <td className="px-3">{consignor.total_discount_given || "N/A"} QAR</td>
                                                                <td className="px-3">
                                                                    <button
                                                                        className="btn btn-outline-primary btn-sm"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            fetchPaymentHistory(
                                                                                consignor?.booking_id ? consignor.booking_id : consignor?.split_id ?? "",
                                                                                consignor?.type
                                                                            );
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-clock-history"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}

                                                        {creditData.consignee?.map((consignee, index) => (
                                                            <tr key={`consignor-${index}`} className="border-bottom">
                                                                <td className="px-3 fw-bold text-capitalize">{consignee.type}</td>
                                                                <td className="px-3 fw-bold">{consignee.customer || "N/A"}</td>
                                                                <td className="px-3">{moment(consignee?.created_at).format('DD-MM-YYYY')}</td>
                                                                <td className="px-3">{consignee.booking_id || "N/A"}</td>
                                                                <td className="px-3">{consignee.total_quantity}</td>
                                                                <td className="px-3">{consignee.booking_value} QAR</td>
                                                                <td className="px-3">{consignee.shipment_id || "N/A"}</td>
                                                                <td>
                                                                    <span className={`badge ${getBadgeClass(consignee?.shipment_status || "N/A")}`}>
                                                                        {consignee?.shipment_status === "Shipment Started" ? "In Transit" : consignee?.shipment_status}
                                                                    </span>
                                                                </td>
                                                                <td className="px-3 text-danger fw-bold">{consignee.credit_value || "N/A"} QAR</td>
                                                                <td className="px-3 text-success fw-bold">{consignee.paided_amount || "N/A"} QAR</td>
                                                                <td className="px-3">{consignee.total_discount_given || "N/A"} QAR</td>
                                                                <td className="px-3">
                                                                    <button
                                                                        className="btn btn-outline-primary btn-sm"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            fetchPaymentHistory(
                                                                                consignee?.booking_id ? consignee.booking_id : consignee?.split_id ?? "",
                                                                                consignee?.type
                                                                            );
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-clock-history"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="modal-footer px-4 py-1 bg-light">
                                    <div className="d-flex justify-content-between align-items-center w-100">
                                        <div className="d-flex gap-4 align-items-center">
                                            <div className="d-flex gap-6 btn">
                                                <div className="d-flex align-items-center mb-2">
                                                    <span className="me-2 text-muted">
                                                        <i className="bi bi-cash-stack text-primary me-1"></i>
                                                        Total Booking Value
                                                    </span>
                                                    <h6 className="mb-0 text-success fw-bold">
                                                        {creditData.totals?.total_booking_value || 0} QAR
                                                    </h6>
                                                </div>
                                                <div className="d-flex align-items-center mb-2">
                                                    <span className="me-2 text-muted">
                                                        <i className="bi bi-receipt text-info me-1"></i>
                                                        Total Received Amount
                                                    </span>
                                                    <h6 className="mb-0 text-primary fw-bold">
                                                        {creditData.totals?.total_received_amount || 0} QAR
                                                    </h6>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <span className="me-2 text-muted">
                                                        <i className="bi bi-percent text-warning me-1"></i>
                                                        Total Credit Amount
                                                    </span>
                                                    <h6 className="mb-0 text-danger fw-bold">
                                                        {Number(creditData.totals?.total_credit_value || 0).toFixed(2)} QAR
                                                    </h6>
                                                </div>

                                            </div>
                                        </div>
                                        <div>
                                            <button
                                                className='btn btn-danger px-4 me-2'
                                                onClick={() => exportCreditData(creditData)}
                                                disabled={!creditData.consignor?.length && !creditData.consignee?.length}
                                            >
                                                Export to Excel
                                            </button>
                                            <button className="btn btn-primary" onClick={() => setShowCreditModal(false)}>
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showHistoryModal && (
                <div className="modal-backdrop shadow-lg rounded-5">
                    <div className="modal fade show d-block" tabIndex={-1} role="dialog">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content pb-3 pt-4">
                                {/* Modal Header */}
                                <div className="modal-header py-2 d-flex justify-content-end">
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => {
                                            setShowHistoryModal(false);
                                            setWhoPaid(null);
                                        }}
                                    ></button>
                                </div>

                                {/* Modal Body */}
                                <div className="modal-body">
                                    <h2 className="mb-4 text-center">Payment History</h2>

                                    {(whoPaid && (whoPaid === "consignee" ? consigneeHistory.length > 0 : consignorHistory.length > 0)) ? (
                                        <table className="table table-striped">
                                            <thead className="table-dark">
                                                <tr>
                                                    <th className='text-end'>S.No</th>
                                                    <th>Booking ID</th>
                                                    <th>Shipment ID</th>
                                                    <th>Paid Amount</th>
                                                    <th>Discount</th>
                                                    <th>Payment Mode</th>
                                                    <th>Paid Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(whoPaid === "consignee" ? consigneeHistory : consignorHistory || []).map((payment, index) => (
                                                    <tr key={index}>
                                                        <td className='text-center'>{index + 1}</td>
                                                        <td>{payment.booking_id}</td>
                                                        <td>{payment.shipment_id}</td>
                                                        <td>{payment.paidamount} QAR</td>
                                                        <td>{payment.discount} QAR</td>
                                                        <td>{payment.who_paid}</td>
                                                        <td>{moment(payment.created_at).format('DD-MM-YYYY')}</td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <h3 className="text-center text-muted">No payment done yet 💰</h3>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showModal && editingCustomer && (
                <div className='modal-backdrop rounded-5'>
                    <div className='modal d-block' tabIndex={-1} role='dialog'>
                        <div className='modal-dialog modal-dialog-centered modal-xl' role='document'>
                            <div className='modal-content'>
                                <div className='modal-content'>
                                    <div className='modal-header'>
                                        <h5 className='modal-title'>Edit Customer</h5>
                                        <button type='button' className='btn-close' onClick={() => closeIcon()}></button>
                                    </div>
                                    <div className='modal-body'>
                                        <form onSubmit={handleEditFormSubmit}>
                                            <div className='row mb-3'>
                                                <div className='col-md-4 mb-3'>
                                                    <label className='form-label'>Name<span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Name"
                                                        value={editingCustomer.name}
                                                        onChange={(e) => {
                                                            const name = e.target.value.replace(/[^a-zA-Z0-9\s]/g, '');
                                                            setEditingCustomer({
                                                                ...editingCustomer,
                                                                name: name.trimStart(),
                                                            });
                                                        }}
                                                        required
                                                    />


                                                </div>
                                                <div className='col-md-4 mb-3'>
                                                    <label className='form-label'>Email<span className="text-danger">*</span></label>
                                                    <input
                                                        type='email'
                                                        className='form-control'
                                                        placeholder='Enter Email'
                                                        value={editingCustomer.email}
                                                        onChange={(e) => setEditingCustomer({ ...editingCustomer, email: e.target.value })}
                                                        required
                                                    />
                                                </div>
                                                <div className='col-md-4 mb-3'>
                                                    <label className='form-label'>Phone Number<span className="text-danger">*</span></label>
                                                    <PhoneInput
                                                        international
                                                        countryCallingCodeEditable={false}
                                                        defaultCountry='AE'
                                                        value={editingCustomer.mobile || ''}
                                                        className='form-control'
                                                        onChange={handleAlterPhoneChange}
                                                        required
                                                        placeholder="Enter phone number"
                                                    />
                                                    {errorss?.mobile && <div className='text-danger'>{errorss.mobile}</div>}
                                                </div>
                                            </div>

                                            <div className="row mb-3">
                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor="country" className="form-label">
                                                        Country<span className="text-danger">*</span>
                                                    </label>
                                                    <Select
                                                        id="country"
                                                        options={countries}
                                                        onChange={handleCountryChange}
                                                        value={country}
                                                        isClearable
                                                        placeholder="Select Country"
                                                        required
                                                    />
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor="state" className="form-label">
                                                        State<span className="text-danger">*</span>
                                                    </label>
                                                    <Select
                                                        id="state"
                                                        options={states}
                                                        onChange={handleStateChange}
                                                        value={state}
                                                        isClearable
                                                        placeholder="Select State"
                                                        required
                                                    />
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor="city" className="form-label">
                                                        City<span className="text-danger">*</span>
                                                    </label>
                                                    <Select
                                                        id="city"
                                                        options={cities}
                                                        onChange={handleCityChange}
                                                        value={city}
                                                        isClearable
                                                        placeholder="Select City"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className='row mb-3'>
                                                <div className='col-md-4 mb-3'>
                                                    <label className='form-label'>Address<span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        placeholder='Enter Address'
                                                        className="form-control"
                                                        value={editingCustomer.address}
                                                        onChange={(e) => {
                                                            const trimmedValue = e.target.value.replace(/^\s+/, '');
                                                            setEditingCustomer({ ...editingCustomer, address: trimmedValue });
                                                        }}
                                                        required
                                                    />

                                                </div>
                                                <div className='col-md-4 mb-3'>
                                                    <label className='form-label'>Landmark</label>
                                                    <input
                                                        type="text"
                                                        placeholder='Enter Landmark'
                                                        className="form-control"
                                                        value={editingCustomer.landmark}
                                                        onChange={(e) => {
                                                            const trimmedValue = e.target.value.replace(/^\s+/, '');
                                                            setEditingCustomer({ ...editingCustomer, landmark: trimmedValue });
                                                        }}
                                                        required
                                                    />

                                                </div>
                                            </div>

                                            <div className='text-end'>
                                                <button type="submit" className="btn btn-primary" disabled={!!errorss?.mobile}>
                                                    Save changes
                                                </button>

                                                <button
                                                    type='button'
                                                    className='btn btn-secondary ms-2'
                                                    onClick={() => closeTab()}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                            <ToastContainer />
                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            )}


            {showSuccessMessage && (
                <div className='modal-backdrop shadow-lg rounded-5'>
                    <div className='modal d-block' tabIndex={-1} role='dialog'>
                        <div className='modal-dialog modal-dialog-centered' role='document'>
                            <div className='modal-content pb-10 pt-4'>
                                <div className='modal-header py-2 d-flex justify-content-end'>

                                    <div className='modal-header py-2 d-flex justify-content-end'>

                                        <span className='close-btn' onClick={() => setShowSuccessMessage(false)}>🗙</span>

                                    </div>
                                </div>
                                <div className='text-center'>
                                    <img alt='Logo' src={toAbsoluteUrl('/media/illustrations/sigma-1/12-dark.png')} className='w-250px mb-6 runningImage' />
                                    <h2>Edited successfully!</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showDeleteConfirmationMessage && (
                <div className='modal-backdrop shadow-lg rounded-5'>
                    <div className='modal d-block' tabIndex={-1} role='dialog'>
                        <div className='modal-dialog modal-dialog-centered' role='document'>
                            <div className='modal-content pb-10 pt-4'>
                                <div className='modal-header py-2 d-flex justify-content-end'>
                                    <span className='close-btn' onClick={() => {
                                        setShowDeleteConfirmationMessage(false)
                                        fetchCustomers()
                                        setSearchValue("")
                                    }

                                    }>🗙</span>
                                </div>
                                <div className='notice d-flex flex-column align-items-center p-6'>
                                    <div>
                                        <KTSVG
                                            path='/media/icons/duotune/general/gen044.svg'
                                            className='svg-icon-2tx svg-icon-warning me-4'
                                        />
                                    </div>
                                    <div className='d-flex flex-column align-items-center'>
                                        <h4>Are you sure you want to delete this Customer?</h4>
                                        <div className='mt-4'>
                                            <button
                                                className='btn btn-danger me-3'
                                                onClick={confirmDeleteCustomer}
                                            >
                                                Confirm
                                            </button>
                                            <button
                                                className='btn btn-secondary'
                                                onClick={() => {
                                                    setShowDeleteConfirmationMessage(false);
                                                    setCustomerToDeleteId(null);
                                                    fetchCustomers()
                                                    setSearchValue("")

                                                }}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showCustomerModal && customerData && (
                <div className="modal-backdrop shadow-lg rounded-5">
                    <div className="modal fade show d-block" tabIndex={-1} role="dialog">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content pb-3 pt-4">
                                <div className="modal-header py-2 d-flex justify-content-end">

                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowCustomerModal(false)}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div className="p-3">
                                        <div className="row mb-3 px-6">
                                            <div className="col-md-6">
                                                <div className="mb-3 d-flex flex-column" style={{ rowGap: '9px' }}>
                                                    <span className="text-sm pb-2">Customer ID:</span>
                                                    <h6>{customerData.user_id}</h6>
                                                </div>
                                                <div className="mb-3 d-flex flex-column" style={{ rowGap: '9px' }}>
                                                    <span className="text-sm">Name:</span>
                                                    <h6>{customerData.name}</h6>
                                                </div>
                                                <div className="mb-3 d-flex flex-column" style={{ rowGap: '9px' }}>
                                                    <span className="text-sm">Email:</span>
                                                    <h6>{!customerData.email || customerData.email === "NULL" ? 'N/A' : customerData.email}</h6>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="mb-3 d-flex flex-column" style={{ rowGap: '9px' }}>
                                                    <span className="text-sm">Phone:</span>
                                                    <h6>{customerData.mobile}</h6>
                                                </div>
                                                <div className="mb-3 d-flex flex-column" style={{ rowGap: '9px' }}>
                                                    <span className="text-sm">Address:</span>
                                                    <h6>{customerData.country === "NULL" ? 'N/A' : customerData.country}</h6>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export { CustomerTable };